export const implementationTypologies = [
  'HYPERCENTER',
  'CENTRE',
  'ZA_COMMERCIAL',
  'ZA_INDUSTRIEL',
  'ZA_TERTIAIRE',
] as const
export type ImplementationTypology = (typeof implementationTypologies)[number]

export const implementationTypologyLabel: Record<ImplementationTypology, string> = {
  HYPERCENTER: 'Hypercentre',
  CENTRE: 'Centre',
  ZA_COMMERCIAL: 'ZA Commerciale',
  ZA_INDUSTRIEL: 'ZA Industrielle',
  ZA_TERTIAIRE: 'ZA Tertiaire',
}
